


































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class VideoPointsView extends Vue {
  public name = 'VideoPointsView'
  @Prop({ default: null })
  public dataList: any[] = []
}
